import { mapEnumToOptions } from '@abp/ng.core';

export enum ROEType {
  Veson = 0,
  Turkish = 1,
}

export const roeTypeOptions = mapEnumToOptions(ROEType);
